/**
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-18 15:02:27
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-20 14:35:44
 * @FilePath: \hzs-nutra-wecom-shop\src\utils\api\customer.js
 * @Description: 客户
 */

import req from "@/utils/axios.js";

export default {
    // 小程序客户列表
    _customerList: (params) => req.get("/wxShop/shop/user/list", params),
    // 企微客户列表
    _customerList2: (params) => req.get("/wxShop/shop/extUser/list", params),

    // 小程序客户详情
    _customerInfo: (params) => req.get("/wxShop/shop/user/info", params),
    // 企微客户详情
    _customerInfo2: (params) => req.get("/wxShop/shop/extUser/info", params),

    // 小程序客户汇总
    _customerMiniStatistics: (params) => req.get("/wxShop/shop/user/bindSummary", params),
    // 企微客户汇总
    _customerQWStatistics: (params) => req.get("/wxShop/shop/extUser/bindSummary", params),

    // 所有的 可用标签
    _customerTags: (params) => req.get("/wxShop/shop/tag/list", params),

    // 给客户绑定标签
    _customerBindTag: (data) => req.post("/wxShop/shop/user/tag/bind", data),
    // 给客户接触标签
    _customerUnbindTag: (data) => req.post("/wxShop/shop/user/tag/unBind", data),

    // 客户积分统计
    _customerPointStatistics: (params) => req.get("/wxShop/shop/user/point", params),
    // 客户账单
    _customerBillList: (params) => req.get("/wxShop/shop/user/point/list", params),

    // 从门店移除员工
    _customerRemoveClerk: (data) => req.post("/wxShop/shop/user/unBind", data),

    // 客户新增
    _customerAdd: (data) => req.post("/wxShop/shop/user/create", data),
    // 客户遍及
    _customerEdit: (data) => req.post("/wxShop/shop/user/edit", data),

    // 客户转移
    _customerTransfer: (data) => req.post("/wxShop/shop/user/transfer", data),
}